import { render } from "./Titleseccions.vue?vue&type=template&id=224a33da&scoped=true"
import script from "./Titleseccions.vue?vue&type=script&lang=js"
export * from "./Titleseccions.vue?vue&type=script&lang=js"

import "./Titleseccions.vue?vue&type=style&index=0&id=224a33da&scoped=true&lang=css"

import exportComponent from "C:\\CEDIS\\cedispage2.0_general_guvi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224a33da"]])

export default __exports__